import { Button, Divider, Tabs, Typography } from 'antd'
import * as React from 'react'
import { FC, useState } from 'react'

import Auth from 'auth'
import { LoginProps, RegistrationProps } from 'auth/types'
import { parseURLParams } from 'shared/helpers'

const { TabPane } = Tabs

function callback(key) {
  // console.log(key)
}

type AuthWizardProps = LoginProps & RegistrationProps

interface CustomTabsProps {
  panes: {
    key: string
    props: {
      tab?: string
    }
  }[]
  activeKey: string
  onTabClick: (newActiveKey: string, he?) => void
}
const CustomTabs: FC<CustomTabsProps> = (props) => {
  const { activeKey, panes, onTabClick } = props

  const activePane = panes.find((pane) => pane.key === activeKey)

  return (
    <header
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
      }}
    >
      <h2
        style={{
          margin: 0,
        }}
      >
        {activePane?.props?.tab ?? activePane?.key}
      </h2>
      <div>
        {panes
          .filter((pane) => pane.key !== activeKey)
          .map((pane, i) => (
            <Typography.Link
              key={i}
              onClick={() => {
                onTabClick(pane.key)
              }}
            >
              {pane?.props?.tab ?? pane?.key}
            </Typography.Link>
          ))}
      </div>
    </header>
  )
}

const AuthWizard: FC<AuthWizardProps> = ({
  onLogin,
  onLoginSuccess,
  onPasswordReset,
  onRequestPasswordReset,
  onSignupSuccess,
}) => {
  const [invitationToken] = useState<string>(parseURLParams([{ key: 'invitation_token' }]).invitation_token)
  const [passwordResetToken] = useState<string>(parseURLParams([{ key: 'reset_password_token' }]).reset_password_token)
  const isRegistrationRedirectPath = parseURLParams([{ key: 'registration' }]).registration === 'true'

  const defaultTab = () => (!invitationToken && !isRegistrationRedirectPath && !passwordResetToken ? 'login' : 'signup')

  return (
    <div style={{ width: 350 }}>
      <Tabs
        defaultActiveKey={defaultTab()}
        renderTabBar={CustomTabs}
        onChange={callback}
        size="large"
        items={[
          {
            label: 'Login',
            key: 'login',
            children: (
              <Auth.LoginForm
                onLogin={onLogin}
                onLoginSuccess={onLoginSuccess}
                onPasswordReset={onPasswordReset}
                onRequestPasswordReset={onRequestPasswordReset}
                passwordResetToken={passwordResetToken}
              />
            ),
          },
          {
            label: 'Sign up',
            key: 'signup',
            children: <Auth.SignupForm onSignupSuccess={onSignupSuccess} />,
          },
        ]}
      />
      {false && !passwordResetToken && (
        <>
          <Divider plain>Or</Divider>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Button style={{ marginTop: 5 }} block href="/users/auth/slack">
              Continue with Slack
            </Button>
            <Button style={{ marginTop: 5 }} block href="/users/auth/github">
              Continue with Github
            </Button>
            <Button style={{ marginTop: 5 }} block href="/users/auth/google">
              Continue with Google
            </Button>
            <Button style={{ marginTop: 5 }} block href="/users/auth/google">
              Continue with Apple
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default AuthWizard
